import { MATCHUPS_UNRANKED_INDEX } from '@pff-consumer/schema'

export const sortByMatchupRank = (p: { grade: { rank: number } }) => {
  if (!p?.grade?.rank) {
    return MATCHUPS_UNRANKED_INDEX
  }

  return p.grade.rank
}
